import { userDataSlice } from "../reducers/user/user.slice";

export const { setUser, setRefreshTokenStatus, removeRefreshToken } =
  userDataSlice.actions;
